var React = require('react');

function Gigs (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1","y":"7","width":"30","height":"21","rx":"2","stroke":"#9F9EAD","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M5.5 11.5H26.5","stroke":"#9F9EAD","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M7.5 11.5V15.5","stroke":"#9F9EAD","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M10.1304 7V2H21.8695V7","stroke":"#9F9EAD","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

Gigs.defaultProps = {"width":"32","height":"30","viewBox":"0 0 32 30","fill":"none"};

module.exports = Gigs;

Gigs.default = Gigs;
